/**
 * Types and constants for Performance Settings components
 */
import { SupplierPerformanceSettings, SupplierRatingThreshold, CreateRatingThresholdData } from '../../../lib/api';

export const MONTH_OPTIONS = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
];

export const WEEK_DAY_OPTIONS = [
  { value: 0, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
];

/**
 * Swatch colours for the empty state only — shown when a company has no
 * configured bands to read a colour from. CR-7079 moved these off the old
 * traffic-light values onto the confirmed metallic baseline so an
 * unconfigured tenant previews what it will actually get. A configured
 * company always renders its own `effective_color` instead.
 */
export const GRADE_COLORS: Record<string, string> = {
  A: '#E5E4E2',
  B: '#D4AF37',
  C: '#C0C0C0',
  D: '#CD7F32',
  F: '#000000',
};

export interface PerformanceFormData {
  // KPI Target Values (for dashboard graphs)
  otif_target: string;
  otd_target: string;
  ppm_target: number;
  // Color Thresholds
  ppm_excellent_threshold: number;
  ppm_good_threshold: number;
  ppm_poor_threshold: number;
  otif_weight: string;
  ppm_weight: string;
  otif_days_early_allowed: number;
  otif_days_late_allowed: number;
  include_arrears_in_otif: boolean;
  arrears_buffer_days: number;
  delivery_metric_mode: 'both' | 'otif_only' | 'otd_only';
  /** CR-6543 r3: schedule-line fallback firm window — staff-only edit */
  default_firm_days: number;
}

export interface ThresholdEditData {
  grade: string;
  label: string;
  min_score: string;
  max_score: string;
  color: string;
  description: string;
  order: number;
}

/** DORMANT — not wired; see PERF-SETTINGS-HIGHS (SupplierOverridePanel only). */
export interface SupplierEditData {
  use_custom_otif_window: boolean;
  otif_days_early_allowed: number;
  otif_days_late_allowed: number;
}

/** DORMANT — not wired; see PERF-SETTINGS-HIGHS (SupplierOverridePanel only). */
export interface SupplierOTIFData {
  id: number;
  company__name: string;
  use_custom_otif_window: boolean;
  otif_days_early_allowed: number;
  otif_days_late_allowed: number;
}

// Re-export API types for convenience
export type { SupplierPerformanceSettings, SupplierRatingThreshold, CreateRatingThresholdData };
